import { render, staticRenderFns } from "./NeiBuFile1.vue?vue&type=template&id=0c60919e&scoped=true&"
import script from "./NeiBuFile1.vue?vue&type=script&lang=js&"
export * from "./NeiBuFile1.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuFile1.vue?vue&type=style&index=0&id=0c60919e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60919e",
  null
  
)

export default component.exports